import React from 'react';
import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Line } from 'recharts';

const DailyCashFlowChart = ({ incomeData, outflowData }) => {
    // Combine dates from both datasets
    const allDates = new Set([...(incomeData || []).map(d => d.date), ...(outflowData || []).map(d => d.date)]);
    const sortedDates = Array.from(allDates).sort();

    const chartData = sortedDates.map(date => {
        const income = incomeData?.find(d => d.date === date)?.value || 0;
        const expense = outflowData?.find(d => d.date === date)?.value || 0;
        return {
            date: new Date(date + 'T12:00:00').toLocaleDateString('es-CO', { day: '2-digit', month: 'short' }),
            Ingresos: income,
            Egresos: expense,
            Neto: income - expense
        };
    });

    const formatCurrency = (val) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(val);

    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-96">
            <h3 className="text-gray-600 font-bold mb-4 flex items-center">
                <span className="w-2 h-6 bg-indigo-500 rounded-full mr-2"></span>
                Comportamiento Diario del Flujo de Caja
            </h3>
            <ResponsiveContainer width="100%" height="100%">
                <ComposedChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                    <XAxis dataKey="date" tick={{ fontSize: 10 }} />
                    <YAxis tickFormatter={(val) => `$${(val / 1000000).toFixed(1)}M`} />
                    <Tooltip
                        formatter={(value) => formatCurrency(value)}
                        contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                    />
                    <Legend />
                    <Bar dataKey="Ingresos" fill="#10B981" name="Entradas" radius={[4, 4, 0, 0]} />
                    <Bar dataKey="Egresos" fill="#EF4444" name="Salidas" radius={[4, 4, 0, 0]} />
                    <Line type="monotone" dataKey="Neto" stroke="#F59E0B" strokeWidth={3} dot={{ r: 4, fill: '#F59E0B' }} name="Neto" />
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
};

export default DailyCashFlowChart;
